module.exports = __webpack_public_path__ + "img/u664b.6b11e53f.jpg";